import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-upload-form"
export default class extends Controller {

  clearBlobs(event) {
    event.preventDefault()
    const clearBlobsForm = document.querySelector("#clear-blobs-form")
    clearBlobsForm?.requestSubmit()
  }
  
}
